import { Collapse } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useErrorBannerStore } from '../../stores/useErrorBannerStore';
import { ERROR_BANNER_NS } from './i18n';
import { Banner, IconSelector, useLinkStyle } from '@diana/core';

export const StreamErrorBanner = () => {
  const { t } = useTranslation(ERROR_BANNER_NS);
  const errors = useErrorBannerStore((state) => state.errors);
  const clearError = useErrorBannerStore((state) => state.clearError);
  const style = useLinkStyle({ isExternal: false, color: 'link' });

  const errorEntries = Object.values(errors);
  const hasErrors = errorEntries.length > 0;

  const handleRetry = () => {
    errorEntries.forEach(({ id, onRetry }) => {
      onRetry?.();
      clearError(id);
    });
  };

  return (
    <Collapse in={hasErrors}>
      <Banner
        title={t('title')}
        richText={false}
        description={
          <span style={{ fontSize: '1rem' }}>
            {t('message.prefix')} {' '}
            <button
              onClick={handleRetry}
              type="button"
              style={{
                ...style,
                cursor: 'pointer',
                backgroundColor: 'transparent',
                border: 'none',
                padding: 0,
                margin: 0,
                fontSize: 'inherit',
              }}
            >
              {t('action.retry')}
            </button>{' '}
            {t('message.suffix')}
          </span>
        }
        severity="warning"
        icon={
          <IconSelector
            value={{ iconColor: 'warning.main', icon: 'WarningOutlined', color: '' }}
            size={24}
            readOnly
          />
        }
      />
    </Collapse>
  );
};
